import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { Client, clientActions, clientSelectors } from "../../../ducks/client";
import { useNavigation } from "../../../hooks/useNavigation";
import { TableHeaderItem, TableSortBy } from "../../../hooks/useTable";
import { AppDispatch } from "../../../store";
import { formatDateTime } from "../../../utils/date";
import { Link } from "../../atoms/Link";

export const useClients = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();

  const clients = useSelector(clientSelectors.clients);

  const fetchClients = useCallback((sort: TableSortBy) => {
    dispatch(appActions.showLoading());

    dispatch(
      clientActions.fetchClients.started({
        // @ts-expect-error
        sort_key: sort.field,
        sort_order: sort.order,
        onComplete: () => dispatch(appActions.hideLoading()),
      }),
    );
  }, []);

  const tableHeaders: TableHeaderItem<Client>[] = useMemo(() => {
    return [
      {
        id: 1,
        title: "顧客ID",
        popupTitle: "顧客ID",
        dataKey: "id",
        sortKey: "id",
      },
      {
        id: 2,
        title: "親顧客ID",
        popupTitle: "親顧客ID",
        dataKey: "parentId",
        sortKey: "parent_id",
      },
      {
        id: 3,
        title: "顧客名",
        popupTitle: "顧客名",
        dataKey: "name",
        sortKey: "name",
        dataMapFunction: ({ id, name }) => ({
          text: name,
          href: PageRoutes.CLIENT_DETAIL.replace(":clientId", `${id}`),
        }),
        customComponent: Link,
      },
      {
        id: 4,
        title: "有効期間",
        popupTitle: "有効期間",
        dataKey: "validPeriod",
        dataMapFunction: ({ validPeriod }) =>
          `${formatDateTime(validPeriod.from, false, "YYYY/MM/DD HH:mm")}〜${formatDateTime(validPeriod.to, false, "YYYY/MM/DD HH:mm")}`,
        sortKey: "valid_from",
      },
    ];
  }, []);

  const handleRegistration = useCallback(() => {
    navigateToPage(PageRoutes.CLIENT_REGISTRATION);
  }, []);

  const handleEdit = useCallback((client: Client) => {
    navigateToPage(PageRoutes.CLIENT_EDIT.replace(":clientId", `${client.id}`));
  }, []);

  return {
    clients,
    tableHeaders,
    fetchClients,
    handleRegistration,
    handleEdit,
  };
};
